import {
  Button,
  ButtonsWrapper,
  Form,
  PLATFORM_THEME_COLORS,
  SelectInput,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useChangeProjectsGantts } from 'src/hooks/projects/change-projects-gantts.hook';

import { ITransferModalsProps } from 'src/pages/settings/components/company/components/company-gantts/components/gantt-form-list/components/transfer-modals.interfaces';
import {
  HeaderContainer,
  WarningContainer,
} from 'src/pages/settings/components/company/components/company-gantts/components/gantt-form-list/components/transfer-modals.styles';

const TransferProjects: FC<
  ITransferModalsProps & {
    projects: any[];
  }
> = ({ projects, gantts, ganttId, isCloseModalAttempt, closeModalAttempt, onSubmit }) => {
  const [projectsRelations, setProjectRelations] = useState<{ [key: string]: string }>({});
  const { t } = useTranslation(['common', 'settings']);

  const changeProjectsGantts = useChangeProjectsGantts();

  const onGanttSelect = (projectId: string) => (ganttId: string) => {
    setProjectRelations(oldValue => ({ ...oldValue, [projectId]: ganttId }));
  };

  const onSubmitTransferProjects = () => {
    const payload = Object.keys(projectsRelations).map(key => ({
      _id: key,
      prevGanttId: ganttId,
      ganttId: projectsRelations[key],
    }));

    changeProjectsGantts({ variables: { payload } });
    onSubmit();
  };

  return (
    <>
      <HeaderContainer>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {t('settings:company.labels.transferProjectsDescription')}
        </Typography>

        <Typography>
          {t('settings:company.labels.numberOfProjects')} <span>{projects.length}</span>
        </Typography>
      </HeaderContainer>

      {isCloseModalAttempt && (
        <WarningContainer>
          <Typography weight="bold" fontColor={PLATFORM_THEME_COLORS.tone.red}>
            {t('settings:permissionGroupSettings.notifications.closeWindow')}
          </Typography>
          <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
            {t('settings:company.notifications.closeTransferProjects')}
          </Typography>
        </WarningContainer>
      )}

      <Form layout="vertical" onFinish={onSubmitTransferProjects}>
        {projects.map((project, index: number) => (
          <Form.Item
            name={[index, 'ganttId']}
            key={project._id}
            label={project.name}
            rules={[{ required: true, message: t('common:validation.error.ganttRequired') }]}
          >
            <SelectInput
              placeholder={t('settings:company.labels.chooseLocation')}
              value={projectsRelations[project._id]}
              onChange={onGanttSelect(project._id)}
            >
              {gantts
                .filter((gantt: any) => gantt._id !== ganttId)
                .map(gantt => (
                  <SelectInput.Option key={gantt._id} value={gantt._id}>
                    {gantt.name}
                  </SelectInput.Option>
                ))}
            </SelectInput>
          </Form.Item>
        ))}
        <ButtonsWrapper>
          <Button htmlType="submit" type="primary">
            {t('common:buttons.save')}
          </Button>
          <Button onClick={() => closeModalAttempt()}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </Form>
    </>
  );
};

export default TransferProjects;
